
// ------------PLACEHOLDER --- TO UPDATE BASED ON CURBIT!!!!!!-------------
   
import api from './apiConfig'

const LOCALSTORAGE_KEY = 'token'

export async function signin(username, credentials) {
  // Make request to singin user to retrieve a token
  const response = await api.post('/auth/signin', {
      username, credentials
  })

  // Put the token on localstorage, for 30min (duration set in server)
  localStorage.setItem(LOCALSTORAGE_KEY, response.data.token)

  return response.data
}

export async function signup(username, credentials) {
  const response = await api.post('/auth/register', {
      username, credentials
  })

  return response.data
}

export async function isTokenValid() {
  const response = await api.get('/auth/isTokenValid')
  return response.data
}